<!-- 排出事業者 基本情報タブ -->
<template>
  <div>
    <validation-observer ref="EmissionBasicFormValidator">
      <v-card
        v-if="emission"
        flat
      >
        <v-card-text class="pt-2">
          <!-- 事業者コード -->
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="事業者コード"
                rules="required|alpha_num_only|max:10"
              >
                <v-text-field
                  v-model="emission.code"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="事業者コード"
                  outlined
                  persistent-placeholder
                  placeholder="例）H001"
                >
                  <template v-slot:label>
                    <span>事業者コード</span>
                    <span class="ml-1">
                      ({{ emission.code?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
             最近使用したコード:&nbsp;<strong>{{ emission.recent_registered_codes }}</strong>
            </v-col>
          </v-row>
          <!-- /事業者コード -->

          <!-- 会社名 -->
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="会社名"
                rules="required|max:60"
              >
                <v-text-field
                  v-model="emission.name"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="会社名"
                  outlined
                  persistent-placeholder
                  placeholder="例）○○○○　株式会社"
                >
                  <template v-slot:label>
                    <span>会社名</span>
                    <span class="ml-1">
                      ({{ emission.name?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /会社名 -->
        </v-card-text>

        <v-card-title class="subtitle-1 pb-0">
          マニフェスト区分
        </v-card-title>

        <v-card-text>
          <!-- マニフェスト区分 -->
          <v-row>
            <v-col cols="12">
              <v-radio-group
                v-model="emission.manifest_type"
                row
                dense
                hide-details="auto"
                class="mt-0"
                @change="setApprovalType"
              >
                <v-radio
                  v-for="n in manifestTypes"
                  :key="n.value"
                  :label="n.text"
                  :value="n.value"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /マニフェスト区分 -->

          <!-- 加入者番号 -->
          <v-row v-if="!isDemoEnv">
            <v-col
              cols="12"
              md="5"
            >
              <validation-provider
                v-slot="{ errors }"
                name="加入者番号"
                :class="emission.manifest_type === 'dxe_form' ? 'requiredMark' : ''"
                :rules="{required: (emission.manifest_type === 'dxe_form'), alpha_num_only: true, length: 7}"
              >
                <v-text-field
                  v-model="emission.subscriber_number"
                  :disabled="emission.usage_stats !== 'not_use' && emission.user_role !== 'support_user'"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  hint="JWNETと連携する場合は必須項目です"
                  label="加入者番号"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）1234567"
                >
                  <template v-slot:label>
                    <span>加入者番号</span>
                    <span class="ml-1">
                      ({{ emission.subscriber_number?.length || 0 }} / 7)
                    </span>

                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append>
                    <v-btn
                      :disabled="disabledSubscriberNumber"
                      outlined
                      small
                      @click="searchDXEEmissionButtonClickEvent"
                    >
                      利用状況確認
                    </v-btn>
                  </template>
                  <template v-slot:append-outer>
                    <v-btn
                      :disabled="!emission.emission_request || emission.emission_request.corporation_code === null"
                      small
                      class="ml-2"
                      color="primary"
                      @click="ediConfirmButtonClickEvent"
                    >
                      EDI申込内容確認
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
              <template>
                <p class="red--text text-left">
                  {{ dxeEmissionMessage }}
                </p>
              </template>
              <v-text-field
                v-if="false"
                v-model="emission.dxe_emission_id"
              >
              </v-text-field>

            </v-col>
          </v-row>
          <!-- /加入者番号 -->

          <!-- 郵便番号 -->
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                :rules="{zip_code: true, required: true, max:8 }"
                class="requiredMark"
                name="郵便番号"
              >
                <v-text-field
                  v-model="emission.zip_code"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  hint="ハイフンを含めて入力してください"
                  label="郵便番号"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）111-1111"
                  required
                >
                  <template v-slot:label>
                    <span>郵便番号</span>
                    <span class="ml-1">
                      ({{ emission.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append-outer>
                    <zip-code-search
                      :zip-code="emission.zip_code"
                      @zipAddress="setEmissionZipAddress"
                    />
                    &nbsp;
                    <v-btn
                      outlined
                      small
                      @click="searchZipButtonClickEvent"
                    >
                      住所→郵便番号
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /郵便番号 -->
          <!-- 都道府県／市区町村 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="都道府県"
                class="requiredMark"
              >
                <v-autocomplete
                  v-model="emission.prefecture_code"
                  :error-messages="errors"
                  :items="prefList"
                  dense
                  hide-details="auto"
                  item-text="text"
                  item-value="value"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                  required
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                rules="required|full_width|max:20"
                name="市区町村"
                class="requiredMark"
              >
                <v-text-field
                  v-model="emission.address_1"
                  :error-messages="errors"
                  dense
                  label="市区町村"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区"
                  required
                >
                  <template v-slot:label>
                    <span>市区町村</span>
                    <span class="ml-1">
                      ({{ emission.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /都道府県／市区町村 -->
          <!-- 町域 -->
          <v-row>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                name="町域"
                rules="full_width|max:40"
              >
                <v-text-field
                  v-model="emission.address_2"
                  :error-messages="errors"
                  dense
                  label="町域"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）日本橋兜町"
                >
                  <template v-slot:label>
                    <span>町域</span>
                    <span class="ml-1">
                      ({{ emission.address_2?.length || 0 }} / 40)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /町域 -->
          <!-- 詳細住所 -->
          <v-row>
            <v-col md="9">
              <validation-provider
                v-slot="{ errors }"
                name="詳細住所"
                rules="max:50"
              >
                <v-text-field
                  v-model="emission.address_3"
                  :error-messages="errors"
                  dense
                  label="詳細住所"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）１−２−３　○○ビル○階"
                >
                  <template v-slot:label>
                    <span>詳細住所</span>
                    <span class="ml-1">
                      ({{ emission.address_3?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /詳細住所 -->
          <!-- 電話番号 -->
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                name="電話番号"
                :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
              >
                <v-text-field
                  v-model="emission.phone_number"
                  :error-messages="errors"
                  dense
                  label="電話番号"
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span>電話番号</span>
                    <span class="ml-1">
                      ({{ emission.phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /電話番号 -->

          <!-- 担当者１／メールアドレス１ -->
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (emission.manifest_type === 'dxe_form' && emission.approval_type === 'use_approval'), email: true, max: 100}"
                name="メールアドレス１"
                :class="{ requiredMark: (emission.manifest_type === 'dxe_form' && emission.approval_type === 'use_approval') }"
              >
                <v-text-field
                  v-model="emission.email_1"
                  :error-messages="errors"
                  dense
                  label="メールアドレス１"
                  hint="EDI申込メールはメールアドレス1（担当者１）のみに送信されます"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）test@dxe.jp"
                  required
                  class="red-hint-field"
                >
                  <template v-slot:label>
                    <span>メールアドレス１</span>
                    <span class="ml-1">
                      ({{ emission.email_1?.length || 0 }} / 100)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="担当者１"
                rules="max:60"
              >
                <v-text-field
                  v-model="emission.staff_1"
                  :error-messages="errors"
                  dense
                  label="担当者１"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder=""
                >
                  <template v-slot:label>
                    <span>担当者１</span>
                    <span class="ml-1">
                      ({{ emission.staff_1?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者１／メールアドレス１ -->

          <!-- 担当者２／メールアドレス２ -->
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                rules="email|max:100"
                name="メールアドレス２"
              >
                <v-text-field
                  v-model="emission.email_2"
                  :error-messages="errors"
                  dense
                  label="メールアドレス２"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）test@dxe.jp"
                >
                  <template v-slot:label>
                    <span>メールアドレス２</span>
                    <span class="ml-1">
                      ({{ emission.email_2?.length || 0 }} / 100)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="担当者２"
                rules="max:60"
              >
                <v-text-field
                  v-model="emission.staff_2"
                  :error-messages="errors"
                  dense
                  label="担当者２"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder=""
                >
                  <template v-slot:label>
                    <span>担当者２</span>
                    <span class="ml-1">
                      ({{ emission.staff_2?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者２／メールアドレス２ -->

          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                name="メモ欄"
                rules="max:30"
              >
                <v-text-field
                  v-model="emission.memo"
                  :error-messages="errors"
                  dense
                  label="メモ欄"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder=""
                >
                  <template v-slot:label>
                    <span>メモ欄</span>
                    <span class="ml-1">
                      ({{ emission.memo?.length || 0 }} / 30)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <!-- 排出者メール承認 -->
          <v-row>
            <v-col cols="12" md="8">
              <h4 class="pt-0">
                排出者メール承認
              </h4>
              <p class="red--text text-left mb-0">&nbsp;利用するを選択した場合、代行起票するためには排出事業者の承認操作が必要になります</p>
              <v-radio-group
                v-model="emission.approval_type"
                row
                dense
                hide-details="auto"
                class="mt-0"
              >
                <v-radio
                  label="利用する"
                  :disabled="emission.manifest_type !== 'dxe_form'"
                  value="use_approval"
                />
                <v-radio
                  label="利用しない"
                  :disabled="emission.manifest_type !== 'dxe_form'"
                  value="none_use_approval"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /排出者メール承認 -->

          <!-- リサイクル希望有無 -->
          <v-row>
            <v-col cols="12" md="6">
              <h4 class="pt-0">
                リサイクル希望
              </h4>
              <v-radio-group
                v-model="emission.use_recycle"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio
                  label="利用する"
                  :value="true"
                />
                <v-radio
                  label="利用しない"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /リサイクル利用有無 -->

          <!-- DXE排出モード -->
        </v-card-text>

        <template
          v-if="emission.id && emission.manifest_type !== 'general_form' && !isEcContractSinglePlan"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <h4 class="pt-0">
                  DXE排出モード
                </h4>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-sheet outlined>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        :disabled="emission.connected"
                        small
                        class="info"
                        @click="invitationButtonClickEvent"
                      >
                        招待する
                      </v-btn>
                      &nbsp;
                      <v-btn
                        :disabled="!emission.connected"
                        small
                        class="error"
                        @click="resetButtonClickEvent"
                      >
                        リセット
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <div class="text-subtitle-2 mb-1">招待日時</div>
                      <div class="text-body-2">
                        <span v-if="emission.send_invitation_at">{{ emission.send_invitation_at }}</span>
                        <span v-else class="grey--text">未招待</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="5">
                      <div class="text-subtitle-2 mb-1">ログインID</div>
                      <div class="text-body-2">
                        <span v-if="emission.login_id">{{ emission.login_id }}</span>
                        <span v-else class="grey--text">-</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="text-subtitle-2 mb-1">前回ログイン日時</div>
                      <div class="text-body-2">
                        <span v-if="emission.last_login_at">{{ emission.last_login_at }}</span>
                        <span v-else class="grey--text">未ログイン</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <!-- /DXE排出モード -->

        <v-card-text>
          <v-row v-if="isBilling">
            <v-col cols="12" md="8">
              <h4 class="pt-0">
                請求先情報
              </h4>
            </v-col>
          </v-row>
          <v-row v-if="isBilling">
            <v-col cols="12" md="6">

              <infinite-billing-auto-complete
                :billing-id="emission.billing_address_id"
                classes="search-font"
                label="請求先"
                @update:values="billingAddressChangedCallback"
              >
                <template v-slot:append-outer>
                  <choose-billing-address-button
                    :small-button="true"
                    @choseBillingAddressCallback="choseBillingAddressCallback"
                  />&nbsp;
                  <v-btn
                    outlined
                    small
                    @click="showDialogButtonClickEvent"
                  >
                    請求先新規登録
                  </v-btn>
                </template>
              </infinite-billing-auto-complete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                name="表示順"
              >
                <v-text-field
                  v-model="emission.sort_priority"
                  :error-messages="errors"
                  dense
                  :show-size="1000"
                  label="表示順"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  reverse
                  type="number"
                  @keydown.69.prevent
                />
              </validation-provider>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <billing-address-detail-dialog
      :enable-dialog="enableDetailDialog"
      :emission="emission"
      @closeEvent="dialogCloseButtonCallback"
      @registerEvent="dialogRegisterButtonCallback"
    />
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="emission.prefecture_code"
      :initial-city-name="emission.address_1"
      :initial-town-name="emission.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
    <confirm ref="confirm" />
    <emission-invitation-dialog
      :enable-dialog="enableEmissionInvitationDialog"
      :emission-id="emission.id"
      @closeCallback="emissionInvitationDialogCloseCallback"
    />
    <edi-confirm-dialog
      :enable-dialog="enableEdiConfirmDialog"
      :form-data="ediConfirmFormData"
      @closeCallback="ediConfirmDialogCloseCallback"
    />

  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Confirm from '../../../../../components/Confirm'
import PrefectureList from '../../../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../../../components/ZipCodeSearch'
import ChooseBillingAddressButton from "../../../../components/ChooseBillingAddressButton";
import BillingAddressDetailDialog from '../dialogs/_billingAddressDialog'
import SearchZipModal from '../../../../components/SearchZipModal.vue'
import EmissionInvitationDialog from '../dialogs/_InvitationDialog'
import EdiConfirmDialog from '../dialogs/_EdiConfirmDialog'
import InfiniteBillingAutoComplete from "@/driver/components/InfiniteBillingAutoComplete.vue";

export default {
  name: 'EmissionBasicForm',
  components: {
    InfiniteBillingAutoComplete,
    Confirm,
    ZipCodeSearch,
    ChooseBillingAddressButton,
    BillingAddressDetailDialog,
    SearchZipModal,
    EmissionInvitationDialog,
    EdiConfirmDialog,
  },
  mixins: [ PrefectureList ],
  props: {
  },
  data () {
    return {
      dxeEmissionMessage: null,
      /** マニフェスト区分 */
      manifestTypes: [],
      emission: {
        id: null,
        name: null,
        subscriber_number: null,
        dxe_emission_id: null,
        dxe_emission_name: null,
        manifest_type: null,
        approval_type: null,
        email_1: null,
        staff_1: null,
        email_2: null,
        staff_2: null,
        use_recycling: null,
        zip_code: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        phone_number: null,
        dxe_emission_registered: false,
        billing_address_id: null,
        memo: null,
        sort_priority: null,
        send_invitation_at: null,
        login_id: null,
        last_login_at: null,
        connected: false,
        emission_request: null,
      },
      /** ダイアログ用 */
      enableDetailDialog: false,
      enableSearchZipModal: false,
      enableEmissionInvitationDialog: false,
      enableEdiConfirmDialog: false,
      ediConfirmFormData: {},
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isEcContractSinglePlan: "use_ec_contract_single_plan",
    }),
    /**
     * 加入者番号の入力制御
     * 登録済の排出事業者でDXE排出事業者が紐付いている場合は変更不可とする
     * @return {boolean}
     */
    disabledSubscriberNumber: function() {
      return (this.emission.id != null && this.emission.dxe_emission_registered)
    }
  },
  watch: {
    'emission.subscriber_number': function (newValue, oldValue) {
      if (!this.emission.dxe_emission_registered) {
        if (oldValue !== null || oldValue !== '') {
          this.dxeEmissionMessage = '加入者番号の入力内容を確認の上利用状況確認ボタンをクリックしてください'
        }
        if (newValue !== oldValue) {
          this.emission.dxe_emission_id = null
        }
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.editEmission({id: this.$route.params.id}).then((content) => {
        this.emission = content
        this.manifestTypes = content.manifest_types
        this.setMessage()
      })
    } else {
      this.newEmission().then((content) => {
        this.emission = content
        this.manifestTypes = content.manifest_types
      })
    }
  },
  methods: {
    ...mapActions('DriverMasterEmission', {
      newEmission: 'new',
      editEmission: 'edit',
      createEmission: 'create',
      updateEmission: 'update',
      deleteEmission: 'destroy',
    }),
    ...mapActions('DriverEmission', {
      resetEmission: 'destroy',
    }),
    ...mapActions('DriverMasterDxeEmission', {
      searchDxeEmission: 'show'
    }),
    searchDXEEmissionButtonClickEvent () {
      this.searchDxeEmission({subscriber_number: this.emission.subscriber_number}).then((content) => {
        if (content.exists) {
          this.emission.dxe_emission_id = content.id
          this.emission.dxe_emission_name = content.name
        }
        this.setMessage()
      })
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEmission({id: this.emission.id }).then(() =>{
            this.$router.push({name: 'DriverMasterEmissions', params: { resetPagination: true }})
          })
        }
      })
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.EmissionBasicFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    sendRegistrationInformation(){
      let params = {
        code: this.emission.code,
        name: this.emission.name,
        subscriber_number: this.emission.subscriber_number,
        dxe_emission_id: this.emission.dxe_emission_id,
        manifest_type: this.emission.manifest_type,
        approval_type: this.emission.approval_type,
        email_1: this.emission.email_1,
        staff_1: this.emission.staff_1,
        email_2: this.emission.email_2,
        staff_2: this.emission.staff_2,
        zip_code: this.emission.zip_code,
        prefecture_code: this.emission.prefecture_code,
        address_1: this.emission.address_1,
        address_2: this.emission.address_2,
        address_3: this.emission.address_3,
        email: this.emission.email,
        phone_number: this.emission.phone_number,
        use_recycle: this.emission.use_recycle,
        memo: this.emission.memo,
        sort_priority: this.emission.sort_priority,
      }

      if (this.emission.billing_address_id) {
        params['billing_address_detail_attributes'] = {billing_address_id: this.emission.billing_address_id}
      } else {
        params['billing_address_detail_attributes'] = {_destroy: true}
      }

      if (this.$route.params.id) {
        this.updateEmission({ id: this.emission.id, params: params }).then(() => {
          this.$emit('callbackToParent')
        })
      } else {
        this.createEmission({ params: params }).then((content) => {
          if (content.id) {
            this.$router.push({name: 'DriverMasterEmissionEdit', params: {id: content.id}})
          }
        })
      }
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.emission.zip_code = address.zip_code
      this.emission.prefecture_code = `${address.prefecture_code}`
      this.emission.address_1 = address.city
      this.emission.address_2 = address.town
    },
    searchZipReflectZipCallback (zipCode) {
      this.emission.zip_code = zipCode;
    },
    cancelButtonClickEvent: function() {
      this.$router.push({ name: 'DriverMasterEmissions' })
    },
    setEmissionZipAddress (content) {
      this.emission.prefecture_code = `${content.pref_code}`
      this.emission.address_1 = `${content.locality}`
      this.emission.address_2 = `${content.street}`
    },
    setMessage () {
      if (this.emission.dxe_emission_id) {
        this.dxeEmissionMessage = '利用可能です。JWNET加入者名：' + this.emission.dxe_emission_name
      } else {
        if (this.emission.subscriber_number) {
          this.dxeEmissionMessage = '利用できない加入者番号です。DXEにお問い合わせ下さい'
        }
      }
    },
    showDialogButtonClickEvent () {
      this.enableDetailDialog = true
    },
    dialogCloseButtonCallback () {
      this.enableDetailDialog = false
    },
    /**
     * ダイアログで登録ボタンが押下された際のコールバック処理
     */
    dialogRegisterButtonCallback (billing_address) {
      /** 請求先リストを再取得 */
      this.emission.billing_address_id = billing_address.id
      this.dialogCloseButtonCallback()
    },
    /**
     * 請求先選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseBillingAddressCallback (item) {
      this.emission.billing_address_id = item.id
    },
    billingAddressChangedCallback (billing_id) {
      this.emission.billing_address_id = billing_id;
    },
    /**
     * EDI以外を選んだら強制的に収運本登録にする
     */
    setApprovalType () {
      if (this.emission.manifest_type !== 'dxe_form') {
        this.emission.approval_type = 'none_use_approval'
      }
    },
    /**
     * 招待ボタン押下イベント
     */
    invitationButtonClickEvent() {
      this.enableEmissionInvitationDialog = true;
    },
    /**
     * リセットボタン押下イベント
     */
    resetButtonClickEvent() {
      let modalOption = {
        title: 'リセット',
        message: 'リセットするとログインができなくなり再度招待が必要になります。よろしいですか？',
        options: { titleColor: 'red' }
      };
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close();
        if (confirm) {
          this.resetEmission({ id: this.emission.id }).then(() => {
            // データを再読み込み
            this.editEmission({id: this.$route.params.id}).then((content) => {
              this.emission = content;
              this.manifestTypes = content.manifest_types;
              this.setMessage();
            });
          });
        }
      });
    },
    /**
     * EDI申込内容確認ボタン押下イベント
     */
    ediConfirmButtonClickEvent() {
      const req = this.emission.emission_request || {}
      this.ediConfirmFormData = {
        jwnet_name: req.jwnet_name,
        corporation_code: req.corporation_code,
        corporate_designation_type: req.corporate_designation_type,
        emission_name: req.emission_name,
        emission_name_kana: req.emission_name_kana,
        emission_location_name: req.emission_location_name,
        emission_location_name_kana: req.emission_location_name_kana,
        representative_last_name: req.representative_last_name,
        representative_first_name: req.representative_first_name,
        representative_last_name_kana: req.representative_last_name_kana,
        representative_first_name_kana: req.representative_first_name_kana,
        zip_code: req.zip_code,
        prefecture_code: req.prefecture_code,
        address_1: req.address_1,
        address_2: req.address_2,
        address_3: req.address_3,
        phone_number: req.phone_number,
        contact_last_name: req.contact_last_name,
        contact_first_name: req.contact_first_name,
        contact_last_name_kana: req.contact_last_name_kana,
        contact_first_name_kana: req.contact_first_name_kana,
        contact_phone_number: req.contact_phone_number,
        email: req.email,
        industry_code: req.industry_code,
        visibility_type: req.visibility_type,
        visibility_url: req.visibility_url,
        jwnet_pricing_type: req.jwnet_pricing_type,
        subscriber_number: req.subscriber_number,
        edi_usage_key: req.edi_usage_key,
      }
      this.enableEdiConfirmDialog = true
    },
    /**
     * EDI申込内容確認ダイアログ閉じるコールバック
     */
    ediConfirmDialogCloseCallback() {
      this.enableEdiConfirmDialog = false
    },
    /**
     * 招待ダイアログ閉じるコールバック
     */
    emissionInvitationDialogCloseCallback() {
      this.enableEmissionInvitationDialog = false;
      // データを再読み込み
      this.editEmission({id: this.$route.params.id}).then((content) => {
        this.emission = content;
        this.manifestTypes = content.manifest_types;
        this.setMessage();
      });
    },
  },

}
</script>


<style scoped lang="scss">
.red-hint-field ::v-deep .v-messages {
  color: red !important;
}
</style>
